/**
 * 语言映射
 * 备注：后端确认过, 除了中国的其他的都是语言二字码(ISO 639-1标准)。中国的有港澳台是做的兼容。
 * @param dataLanguage
 * @returns
 */
export function preHandlerDataLanguage(dataLanguage) {
    var mapString = {
        'en-US': 'EN',
        'es-ES': 'ES',
        'fr-FR': 'FR',
        'ja-JP': 'JA',
        'ko-KR': 'KO',
        'pl-PL': 'PL',
        'pt-PT': 'PT',
        'ru-RU': 'RU',
        'tr-TR': 'TR',
        'zh-CN': 'CN',
        'zh-HK': 'CN_HK',
        'zh-TW': 'CN_TW',
        'zh-MO': 'CN',
    };
    if (mapString[dataLanguage])
        return mapString[dataLanguage];
    return dataLanguage;
}
